import TimeRounding from './TimeRounding';

export default TimeRounding;
